module.exports = __webpack_public_path__ + "static/img/box.c078c43b.png";